// extracted by mini-css-extract-plugin
export var cardIcon = "_af-4";
export var checkboxCard = "_af-0";
export var checkboxCardSelected = "_af-3";
export var disabled = "_af-1";
export var outerBorder = "_af-2";
export var spacerMedium = "_af-7";
export var spacerSmall = "_af-6";
export var spacerXsmall = "_af-5";